var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12260_1479)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60135 0C2.06562 0 0 2.06548 0 4.60121V31.3987C0 33.9344 2.06562 36 4.60135 36H31.3988C33.9345 36 36 33.9344 36 31.3987V4.60121C36 2.06548 33.9345 0 31.3988 0H4.60135ZM6.51572 5.74228C7.99082 5.74228 9.20325 6.9547 9.20325 8.42981C9.20325 9.90492 7.99082 11.1173 6.51572 11.1173C5.04061 11.1173 3.82819 9.90492 3.82819 8.42981C3.82819 6.9547 5.04061 5.74228 6.51572 5.74228ZM14.172 5.74228H29.4848C30.9603 5.74228 32.1722 6.95422 32.1722 8.42967V8.42981C32.1722 9.90526 30.9603 11.1173 29.4848 11.1173H14.172C12.6965 11.1173 11.4846 9.90526 11.4846 8.42981V8.42967C11.4846 6.95422 12.6965 5.74228 14.172 5.74228ZM6.51572 15.3123C7.99082 15.3123 9.20325 16.5248 9.20325 17.9999C9.20325 19.475 7.99082 20.6874 6.51572 20.6874C5.04061 20.6874 3.82819 19.475 3.82819 17.9999C3.82819 16.5248 5.04061 15.3123 6.51572 15.3123ZM14.172 15.3123H29.4848C30.9603 15.3123 32.1722 16.5243 32.1722 17.9997V18C32.1722 19.4754 30.9603 20.6874 29.4848 20.6874H14.172C12.6965 20.6874 11.4846 19.4754 11.4846 18V17.9997C11.4846 16.5243 12.6965 15.3123 14.172 15.3123ZM6.51572 24.8831C7.99082 24.8831 9.20325 26.0955 9.20325 27.5706C9.20325 29.0457 7.99082 30.2581 6.51572 30.2581C5.04061 30.2581 3.82819 29.0457 3.82819 27.5706C3.82819 26.0955 5.04061 24.8831 6.51572 24.8831ZM14.172 24.8831H29.4848C30.9603 24.8831 32.1722 26.095 32.1722 27.5705V27.5706C32.1722 29.0461 30.9603 30.2581 29.4848 30.2581H14.172C12.6965 30.2581 11.4846 29.0461 11.4846 27.5706V27.5705C11.4846 26.095 12.6965 24.8831 14.172 24.8831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12260_1479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2);
export default __webpack_public_path__ + "static/media/h2.24e89ff47163492e64c2d61a95b42656.svg";
export { ForwardRef as ReactComponent };